import securityExtensionRoutes from './securityExtensionRoutes';

export default [
  {
    name: 'engagement'
  },
  {
    name: 'data-sources',
    isHidden: props => !props.abilities.canViewDataSourcesAnalysis
  },
  {
    name: 'data-sources-by-area',
    isHidden: props => !props.abilities.canViewDataSourcesAnalysis
  },
  {
    name: 'overview',
    isHidden: props => !props.abilities.canViewOverviewAnalysis
  },
  {
    name: 'overview/:areaId',
    isHidden: props => !props.abilities.canViewOverviewAnalysis
  },
  ...securityExtensionRoutes,
  {
    name: 'overlap/:areaId',
    isHidden: props => !props.abilities.canViewOverlapAnalysis
  }
];




// WEBPACK FOOTER //
// ./src/routing/analytics/routes.js